import { api } from "@";
import type {
  CreateCampaignFormData,
  CreateCampaignResponse,
  GetCampaignResponse,
  GetCampaignsResponse,
  PaginatedResponse,
  WhatsappTemplate,
} from "../types";
import { formatFilterCriteria } from "@/features/marketing/whatsapp-campaign/lib/filter-criteria-format.ts";

// Fetch WhatsApp campaigns with pagination
export const getWhatsappCampaigns = (
  page: number = 1,
  perSize: number = 10,
  search: Record<string, unknown> | object = {},
): Promise<GetCampaignsResponse> => {
  return api.post("/api/AdminWhatsappCampaign", {
    page,
    pageSize: perSize,
    ...search,
  });
};

// Create a new WhatsApp campaign
export const createWhatsappCampaign = (
  data: CreateCampaignFormData,
): Promise<CreateCampaignResponse> => {
  const formattedFilterCriteria = formatFilterCriteria(data);
  const payload = {
    name: data.name,
    description: data.description,
    template: {
      templateId: data.template?.value,
      templateName: data.template?.label,
    },
    filterCriteria: formattedFilterCriteria,
  };
  return api.post("/api/AdminWhatsappCampaign/create-campaign", payload);
};

// Get campaign details by ID
export const getWhatsappCampaign = (
  id: string,
): Promise<GetCampaignResponse> => {
  return api.get(`/api/AdminWhatsappCampaign/${id}`);
};

// Get WhatsApp templates
export const getWhatsappTemplates = async (
  page: number = 1,
  pageSize: number | null = null,
): Promise<PaginatedResponse<WhatsappTemplate>> => {
  const { data } = await api.get("/api/AdminWhatsappCampaign/templates", {
    params: { Page: page, PageSize: pageSize },
  });
  return data;
};

// Calculate users count based on filter criteria
export const calculateUsersCount = (
  filterCriteria: CreateCampaignFormData,
): Promise<{ data: number }> => {
  const payload = formatFilterCriteria(filterCriteria);
  return api.post("/api/AdminWhatsappCampaign/calculate-users-count", payload);
};
